// src/icons/LightningOnRoundedSquare.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function LightningOnRoundedSquare() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { width: "16", height: "16", rx: "2", fill: "#FFF14E" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6.73918 10.2677L5.48342 13L12.0306 7.24169H8.59885L8.9703 6.43284L10.5472 3L4 8.75831H7.43176L7.06031 9.56716L6.73918 10.2677Z",
            fill: "black"
          }
        )
      ]
    }
  );
}

export {
  LightningOnRoundedSquare
};
